document.addEventListener('DOMContentLoaded', () => {
  const gsap = window.app.gsap
  const sections = document.getElementsByClassName('section')
  
  for (const section of sections) {
    // Handle kaleidoscope scaling
    const kaleidoscopeScale = section.getAttribute('data-kaleidoscope-scale')
    if (kaleidoscopeScale) {
      section.style.setProperty('--kaleidoscope-scale', kaleidoscopeScale)
    }
    if (section.classList.contains('is-style-history')) {
      const poster = section.querySelector('.section__background-poster')
      const bottle = section.querySelector('.section__background-bottle')

      gsap.set(poster, { rotation: 3, yPercent: -58 })
      gsap.to(poster, {
        rotation: 0,
        yPercent: -58,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'center 30%',
          scrub: 1
        }
      })

      gsap.set(bottle, { rotation: -3, yPercent: -50 })
      gsap.to(bottle, {
        rotation: 0,
        yPercent: -50,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'center 30%',
          scrub: 1
        }
      })
    }
  }

})
